import * as _ from 'underscore';
import { DataAlertRecipientInfo, DataAlertRecipientInfoType, IDataAlertInfo } from '../models/IDataAlertInfo';
import { IDataAlert, IDataAlertRecipient } from '../ServerApi/types/IDataAlert';
import { IGroup } from '../ServerApi/types/IGroup';
import { IUser } from '../ServerApi/types/IUser';
import { UserMapper } from './UserMapper';

export module DataAlertMapper {

  export function map(
    dataAlerts: IDataAlert[],
    users: _.Dictionary<IUser>,
    groups: _.Dictionary<IGroup>
  ): IDataAlertInfo[] {

    return _.map(dataAlerts, (a: IDataAlert): IDataAlertInfo => {
      return {
        id:                           a.id,
        name:                         a.title,
        owner:                        UserMapper.mapOne(users[a.ownerId]),
        context:                      a.context,
        displayRecipients:            mapDisplayRecipientsInfo(a.displayRecipients, users, groups),
        recipientsCount:              a.recipientsCount,
        isCurrentUserSubscribed:      a.isCurrentUserSubscribed,
        lastChecked:                  a.lastChecked ? new Date(a.lastChecked) : null,
        lastSentForCurrentUser:       a.lastSentForCurrentUser ? new Date(a.lastSentForCurrentUser) : null,
        notificationIntervalInMinutes:a.notificationIntervalInMinutes,
        deviceType:                   a.deviceType,
        suspendState:                 a.suspendState,
        isPublic:                     a.isPublic,
        contentType:                  'dataalert',
      };
    });
  }

  function mapDisplayRecipientsInfo(recipients: IDataAlertRecipient[], users: _.Dictionary<IUser>,
                                    groups: _.Dictionary<IGroup>) {
    return _.map(recipients, r => {
      const recipientInfo: DataAlertRecipientInfo = {
        type: r.type
      };

      if (DataAlertRecipientInfoType.isUser(recipientInfo)) {
        recipientInfo.user = UserMapper.mapOne(users[r.id]);
      } else if (DataAlertRecipientInfoType.isGroup(recipientInfo)) {
        recipientInfo.group = {...groups[r.id], contentType: 'group'};
      }

      return recipientInfo;
    });
  }

}
